import { Microfrontend } from '@cian/mf-react';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { useSearchStringManifestInfo } from '../../hooks/useSearchStringManifestInfo';

interface ISearchStringMicrofrontendProps {
  isStretched?: boolean;
}

export const SearchStringMicrofrontend = ({ isStretched = false }: ISearchStringMicrofrontendProps) => {
  const manifestInfo = useSearchStringManifestInfo();

  if (!manifestInfo) {
    return null;
  }

  return (
    <div
      className={cn(styles['container'], isStretched && styles['container_stretched'])}
      data-testid="search-string-microfrontend"
    >
      <Microfrontend {...manifestInfo} />
    </div>
  );
};
